declare const grecaptcha: any;

/**
 * Generates a recaptcha enterprise token
 */
export function fillRecaptchaToken(
    siteKey: string,
    callback: (token: string, action?: string) => void,
    action: string = "submit" // default value
) {    

    // grecaptcha must exist
    if (typeof grecaptcha === "undefined") {
        console.warn("grecaptcha not loaded yet");
        return callback("", action);
    }

    // Enterprise reCAPTCHA enterprise uses grecaptcha.enterprise instead of grecaptcha
    grecaptcha.enterprise.ready(() => {
        grecaptcha.enterprise.execute(siteKey, { action })
            .then((token: string) => callback(token || "", action))
            .catch((err: any) => {
                console.error("grecaptcha execute error:", err);
                callback("", action);
            })
    });
}